import React, { useCallback, useState } from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, number, oneOfType, shape, string,
} from 'prop-types'

import DataTable from 'Pods/Shared/DataTable/DataTable'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import { subscriptionColumns } from '../../../Static/subscriptionColumns'

function SubscriptionDetailTable({ rows = EMPTY_ARRAY, isLoading = false }) {
  const [sortKey, setSortKey] = useState(null)
  const [sortDirection, setSortDirection] = useState(null)

  const handleSort = useCallback((key, nextDirection) => {
    setSortKey(nextDirection ? key : null)
    setSortDirection(nextDirection)
  }, [])

  if (isLoading) {
    return (
      <div className="subscription-detail-panel__table-wrapper">
        <div className="spinner-container">
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div className="subscription-detail-panel__table-wrapper">
      <DataTable
        columns={subscriptionColumns}
        data={rows}
        sortKey={sortKey}
        sortDirection={sortDirection}
        onSort={handleSort}
      />
    </div>
  )
}

SubscriptionDetailTable.propTypes = {
  rows: arrayOf(shape({
    id: oneOfType([string, number]),
    model: string,
    monthlyEarnings: number,
    totalEarned: number,
    publishedDate: string,
    optedInDate: string,
  })),
  isLoading: bool,
}

export default SubscriptionDetailTable
